import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";

interface ICourse {
    mshied_courseid: string;
    mshied_name: string;
    slcm_courseid: string;
}

export const useGetCoursesName = () => {
    const { user, siteId } = useAuth();
    const [getCourses] = useLazyReadMultipleQuery();
    const [courses, setCourses] = useState<Map<string, { name: string; code: string }>>(new Map());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCourses = async () => {
            if (!user?.contactId) return;

            setLoading(true);

            try {
                const data = await getCourses({
                    userId: user?.userId || "",
                    portalId: siteId || "",
                    tableId: "mshied_course",
                    fieldList: ["mshied_courseid", "mshied_name", "slcm_courseid"],
                    filters: [],
                }).unwrap();

                const courseMap = new Map<string, { name: string, code: string }>(
                    (data.records as ICourse[]).map(
                        (p) => [p.mshied_courseid, { name: p.mshied_name, code: p.slcm_courseid }]
                    )
                );

                setCourses(courseMap);
            } catch (error) {
                console.error("Error fetching courses:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, [user, siteId, getCourses]);

    const getCourseDetails = (key: string) => courses.get(key) || { name: "", code: "" };

    return { getCourseDetails, loading };
};